module.exports = __webpack_public_path__ + "static/media/joshiraku.fb2ad99a.png";